import Vue from 'vue'
import Router from 'vue-router'

//Portaus portal
import CustomerInvoicesList from '../views/pages/portal/invoices/invoices.vue'

//Portaus admin
import Customers from '../views/pages/customer/Customer-list.vue'
import Customer from '../views/pages/customer/Customer.vue'
import Contacts from '../views/pages/contact/Contact-list.vue'
import Contact from '../views/pages/contact/Contact.vue'

//Inventaires
import Items from '../views/pages/inventory/items.vue'
import PurchaseOrders from '../views/pages/inventory/purchase-orders.vue'
import PurchaseOrder from '../views/pages/inventory/purchase-order.vue'

//Sales
import SalesOrders from '../views/pages/salesOrder/sales-orders.vue'
import SalesOrder from '../views/pages/salesOrder/sales-order.vue'
import Invoices from '../views/pages/invoice/invoices.vue'
import Invoice from '../views/pages/invoice/invoice.vue'
//reservationCreatorVisible
import Reservation from '../views/pages/reservations/reservation.vue'
import Reservations from '../views/pages/reservations/reservations.vue'

//Configuration
import Settings from '../views/pages/settings/index.vue'
import Import from '../views/pages/settings/import/Import.vue'
import CustomFields from '../views/pages/settings/customFields/customFields.vue'
import Users from '../views/pages/settings/users/users.vue'
import Inventories from '../views/pages/settings/inventories/Inventories.vue'
import ItemsAdmin from '../views/pages/settings/inventories/Items.vue'
import Reports from '../views/pages/settings/reports/reports.vue'
import Report from '../views/pages/settings/reports/report.vue'
import Tags from '../views/pages/settings/tags/tags.vue'
import Datagrapes from '../views/pages/settings/datagrapes/datagrapes.vue'
import Carousel from '../views/pages/settings/carousel/index.vue'
import Business from '../views/pages/settings/business/business.vue'
//apps
import Dashboard from '../views/apps/Dashboard.vue'
import Calendar from '../views/apps/Calendar.vue'



//pages
import Login from '../views/pages/authentication/Login.vue'
// import Register from '../views/pages/authentication/Register.vue'
import RecoverPassword from '../views/pages/authentication/RecoverPassword.vue'
import NotFound from '../views/pages/NotFound.vue'


import CreditNotes from '../views/pages/creditNotes/creditNotes.vue'
import CreditNote from '../views/pages/creditNotes/creditNote.vue'

import EmailCustomContentSettigns from '../views/pages/settings/EmailCustomContent/emailCustomContent'


//CMS
import Galleries from '../views/pages/CMS/galleries.vue'
import Providers from '../views/pages/CMS/providers.vue'
import Provider from '../views/pages/CMS/provider.vue'
import Blogs from '../views/pages/CMS/blogs.vue'
import Blog from '../views/pages/CMS/blog.vue'
import Products from '../views/pages/CMS/products.vue'
import Product from '../views/pages/CMS/product.vue'
import CMSSettings from '../views/pages/CMS/settings.vue'

import layouts from '../layout'
import store from '../store/store'

import ability from '../core/ability'


import { AUTH_LOGOUT } from '../store/actions/auth'

Vue.use(Router)


const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/customers',
			name: 'customers',
			component: Customers,
			meta: {
				auth: true,
				abilities : [{ressource : "Customer", ability:"read"}],
				layout: layouts.navLeft,
				searchable: true
			}
		},
		{
			path: '/customers/invoices',
			name: 'CustomerInvoicesList',
			component: CustomerInvoicesList,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true
			}
		},
		{

			path: '/credit-notes',
			name: 'CreditNotes',
			component: CreditNotes,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				abilities : [{ressource : "CreditNote", ability:"read"}],
				searchable: true
			}
		},
		{
			path : '/credit-notes/:id',
			name : 'CreditNote',
			component : CreditNote,
			meta : {
				auth : true,
				layout : layouts.navLeft,
				abilities : [{ressource : "CreditNote", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/customers/:id',
			name : 'Customer',
			component : Customer,
			meta : {
				auth : true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Customer", ability:"read"}],
				searchable : false
			}
		},{
			path : '/contacts',
			name : 'Contacts',
			component : Contacts,
			meta : {
				auth : true,
				abilities : [{ressource : "Contacts", ability:"read"}],
				layout : layouts.navLeft,
				searchable : false
			}
		},
		// {
		// 	path : '/contacts/contact-form/:id?',
		// 	name : 'ContactForm',
		// 	component : ContactForm,
		// 	meta : {
		// 		auth : true,
		// 		layout : layouts.navLeft,
		// 		searchable : false
		// 	}
		// },
		{
			path : '/contacts/:id',
			name : 'Contact',
			component : Contact,
			meta : {
				auth : true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Contacts", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/inventories/:id/items',
			name : 'items',
			component : Items,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Inventories", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/inventories/:id/purchase-orders/:purchaseOrderId',
			name : 'purchaseOrder',
			component : PurchaseOrder,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Inventories", ability:"read"},{ressource : "PurchaseOrders", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/inventories/:id/purchase-orders',
			name : 'purchaseOrders',
			component : PurchaseOrders,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Inventories", ability:"read"},{ressource : "PurchaseOrders", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/sales-orders',
			name : 'SalesOrders',
			component : SalesOrders,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "SalesOrders", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/sales-orders/:salesOrderId',
			name : 'SalesOrder',
			component : SalesOrder,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "SalesOrders", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/reservations/:reservationId',
			name : 'Reservation',
			component : Reservation,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "SalesOrders", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/reservations',
			name : 'Reservations',
			component : Reservations,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "SalesOrders", ability:"read"}],
				searchable : false
			}
		},{
			path : '/settings/import',
			name : 'Import',
			component : Import,
			meta : {
				auth : true,
				layout : layouts.navLeft,
				abilities : [{ressource : "SalesOrders", ability:"read"}],
				searchable : false
			}
		},{
			path : '/settings/custom-fields',
			name : 'CustomFields',
			component : CustomFields,
			meta : {
				auth : true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Manage", ability:"all"}],
				searchable : false
			}
		},
		{
			path : '/settings/users',
			name : 'users',
			component : Users,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Manage", ability:"all"}],
				searchable : false
			}
		},
    {
			path : '/settings',
			name : 'settings',
			component : Settings,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [
          {ressource : "all", ability:"manage"},
          // {ressource : "read", ability:"Reports"},
          // {ressource : "read", ability:"SalesReports"},
          // {ressource : "manage", ability:"CMS"},
          {ressource : "manage", ability:"CRM config"}
        ],
				searchable : false
			}
		},
		{
			path : '/settings/inventories',
			name : 'inventories',
			component : Inventories,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Inventories", ability:"manage"}],
				searchable : false
			}
		},
		{
			path : '/settings/items',
			name : 'itemsAdmin',
			component : ItemsAdmin,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Inventories", ability:"manage"}],
				searchable : false
			}
		},
		{
			path : '/settings/email-custom-content',
			name : 'EmailCustomContentSettigns',
			component : EmailCustomContentSettigns,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "all", ability:"manage"}],
				searchable : false
			}
		},
		{
			path : '/settings/tags',
			name : 'tags',
			component : Tags,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "all", ability:"manage"}],
				searchable : false
			}
		},
		{
			path : '/settings/CMS/carousels',
			name : 'carousel',
			component : Carousel,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "CMS", ability:"manage"}],
				searchable : false
			}
		},
		{
			path : '/settings/datagrapes',
			name : 'datagrapes',
			component : Datagrapes,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "all", ability:"manage"}],
				searchable : false
			}
		},
    {
			path : '/settings/Business',
			name : 'tags',
			component : Business,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "all", ability:"manage"}],
				searchable : false
			}
		},
		{
			path : '/reports',
			name : 'reports',
			component : Reports,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Reports", ability:"read"}, {ressource : "SalesReports", ability:"read"}],
				searchable : false
			}
		},
		{
			path : '/reports/:code',
			name : 'report',
			component : Report,
			meta : {
				auth:true,
				layout : layouts.navLeft,
				abilities : [{ressource : "Reports", ability:"read"}, {ressource : "SalesReports", ability:"read"}],
				searchable : false
			}
		},
		{
			path: '/',
			alias: '/dashboard',
			name: 'dashboard',
			component: Dashboard,
			meta: {
				auth: true,
				anonymous_auth : true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['app']
			}
		},
		{
			path: '/calendar',
			name: 'calendar',
			component: Calendar,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['app']
			}
		},
		{
			path: '/invoices',
			name: 'invoices',
			component: Invoices,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				abilities : [{ressource : "Invoices", ability:"read"}],
				tags: ['pages']
			}
		},
		{
			path: '/invoices/:invoiceId',
			name: 'invoice',
			component: Invoice,
			meta: {
				auth: true,
				abilities : [{ressource : "Invoices",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/galleries',
			name: 'galleries',
			component: Galleries,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/providers',
			name: 'providers',
			component: Providers,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/provider',
			name: 'NewProvider',
			component: Provider,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
    {
			path: '/settings/CMS/blogs',
			name: 'blogs',
			component: Blogs,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/blog',
			name: 'newBlog',
			component: Blog,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
    {
			path: '/settings/CMS/blogs/:blogId',
			name: 'Blog',
			component: Blog,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/products',
			name: 'products',
			component: Products,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/product',
			name: 'NewProduct',
			component: Product,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/providers/:providerId',
			name: 'provider',
			component: Provider,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/products/:productId',
			name: 'product',
			component: Product,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"read"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/settings/CMS/settings',
			name: 'CMSSettings',
			component: CMSSettings,
			meta: {
				auth: true,
				abilities : [{ressource : "CMS",ability:"manage"}],
				layout: layouts.navLeft,
				searchable: true,
				tags: ['pages']
			}
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				layout: layouts.contenOnly
			}
		},
		// {
		// 	path: '/register',
		// 	name: 'register',
		// 	component: Register,
		// 	meta: {
		// 		layout: layouts.contenOnly
		// 	}
		// },
		{
			path: '/recover-password',
			name: 'recover-password',
			component: RecoverPassword,
			meta: {
				layout: layouts.contenOnly
			}
		},
		{
			path: '/logout',
			beforeEnter (to, from, next) {
				auth.logout()
				// console.log(to.query.session);
				if(to.query.session){
					next({path:'/login?session='+to.query.session})
				}else{
					next({path:'/login'})
				}
			}
		},
		{
			path: '*',
			name: 'not-found',
			component: NotFound,
			meta: {
				layout: layouts.contenOnly
			}
		}
	]
})


const l = {
	contenOnly(){
		store.commit('setLayout', layouts.contenOnly)
	},
	navLeft(){
		store.commit('setLayout', layouts.navLeft)
	},
	navRight(){
		store.commit('setLayout', layouts.navRight)
	},
	navTop(){
		store.commit('setLayout', layouts.navTop)
	},
	navBottom(){
		store.commit('setLayout', layouts.navBottom)
	},
	set(layout){
		store.commit('setLayout', layout)
	}
}

//insert here login logic
const auth = {
	loggedIn(query) {
		return store.getters.isAuthenticated;
	},
	isAnonymous(){
		return store.getters.isAnonymousAuth
	},
	logout() {
		store.commit(AUTH_LOGOUT);
		localStorage.removeItem('access-token');
    	localStorage.removeItem('portaus-context-token');
		localStorage.removeItem('refresh-token');
		localStorage.removeItem('user');
		localStorage.removeItem('profileId');
	},
	softAuthRequest(token){
		return store.dispatch('ANONYMOUS_AUTH_REQUEST', token)
	},
	redirectTo(url){
		window.location.href = url
	},
	checkAut(to){
		return new Promise((resolve,reject)=>{
			if(to.query.token){

				return auth.softAuthRequest(to.query.token)
					.then(resp => {
						resolve(resp);
					})
					.catch(err=>{
						reject(err);
					})
			}else if(localStorage.user && JSON.parse(localStorage.user).anonymous){
				localStorage.removeItem('access-token');
				localStorage.removeItem('refresh-token');
				resolve();
			}else{
					resolve();
			}
		})

	}
}

router.beforeEach((to, from, next) => {

	let authrequired = false
	if(to && to.meta && to.meta.auth)
		authrequired = true

	auth.checkAut(to)
		.then(()=>{
			if(auth.loggedIn() && !auth.isAnonymous()){
				return store.dispatch('AUTH_GET_ME')
					.then((me)=>{
						ability.update(me.rules);
						store.dispatch('inventory/fetchInventories');
						store.dispatch('controlData/fetchCMSConfiguration');
					})
			}
		})
		.then(()=>{
			if(authrequired) {
				if(auth.loggedIn()) {
					if(to.name === 'login') {
						auth.redirectTo('/');
						return false
					} else {
						next()
					}
				} else {
					if(to.name !== 'login'){
						auth.redirectTo('/login');
						return false
					}
					next()
				}
			} else {
				if(auth.loggedIn() && to.name === 'login'){
					auth.redirectTo('/');
					return false
				} else {
					next()
				}
			}

			if(to.meta && to.meta.abilities){
				let can=false;
				_.forEach(to.meta.abilities, a=>{
					if(ability.can(a.ability, a.ressource)){
						can = true;
					}
				})
				if(!can)next({ name: 'not-found' });
			}



			if(to && to.meta && to.meta.layout){
				l.set(to.meta.layout)
			}
		})
		.catch(err=>{
			auth.logout();
			auth.redirectTo('/login');
		})


})

router.afterEach((to, from) => {
	setTimeout(()=>{
		store.commit('setSplashScreen', false)
	}, 500)
})

export default router
